// This file will be removed in AUB-11258
/* eslint-disable @typescript-eslint/no-unsafe-return */
export const TOKEN_INFO = 'TOKEN_INFO'

export const decodeAuthToken = (authToken: string) => JSON.parse(
  atob(
    authToken.split('.')[1]
  )
)
